import {forwardRef} from 'react';
import cx from 'classnames';

import * as css from './Toggle.css';

/**
 * Toggle inputs allow the user to select a boolean value, either true or false
 *
 * The Toggle component renders a styled `<span>` element with a Toggle `<input>`
 * as one of its children, for styling purposes.
 *
 * All HTML attributes are supported, and forwarded to the corresponding `input`
 * element. The className prop, however, is placed on the root node, to aid in
 * applying custom styles to any of the components children, via child
 * selectors.
 *
 * `ref`s are forwarded to the `input` element.
 */
export const Toggle = forwardRef<HTMLInputElement, React.ComponentPropsWithRef<'input'>>(
  ({className, ...otherProps}, ref) => (
    <span className={cx(css.root, className)}>
      <input className={css.input} ref={ref} type="checkbox" {...otherProps} />
      <span className={css.indicator} />
    </span>
  ),
);
